const en = () => {
    const all = {
        appName: 'Templating',
        me: 'Me',
        items: '[0] no items |[1] one item |[2,4] {count} items',
        existence: '[0] nothing |[1] One |[2,4] Less then five |[5,*] Five or more ',
        test: '[0] {countAsString} no items |[1] one item |[2,4] {countAsString} ({count}) items',
        loginPlaceholder: 'Username or email',
        cantLogin: 'Can not login',
        pwdPlaceholder: 'Password',
        loading: 'Loading',
        loadingExt: 'Loading {ext}',
        saving: 'Saving',
        savingExt: 'Saving {ext}',
        sending: 'Sending',
        sendingExt: 'Sending {ext}',
        validating: 'Validating',
        validatingExt: 'Validating {ext}',
        search: 'Search',
        filterType: 'Type',
        filterRole: 'Role',
        Dashboard: 'Dashboard',
        Template: 'Template edit',
        Templates: 'Templates',
        TemplateVersions: 'Template versions',
        TemplateTools: 'Tools',
        TemplateFormat: 'Format',
        TemplateBasics: 'Basics',
        Tester: 'Template testing',
        Placeholders: 'Placeholders',
        Placeholder: 'Placeholder detail',
        Snippets: 'Snippets',
        Snippet: 'Snippet detail',
        Tags: 'Tags',
        Tag: 'Tag',
        Files: 'Files',
        File: 'File',
        BatchImport: 'Batch processing',
        WysiwygEditor: 'Editor',
        SourceCode: 'Source code',
        Profile: 'Profile',
        MyProfile: 'My profile',
        Sorry: 'Sorry',
        Error: 'Error',
        NoPermission: 'You have no permission for {path}',
        MissingRequired: 'Mandatory data is missing: {subject}',
        Users: 'Users',
        role: 'Role',
        userName: 'Username',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        snippetName: 'Snippet name',
        snippetType: 'Snippet type',
        snippetSource: 'Snippet source',
        snippetPreview: 'Snippet preview',
        notFound: 'Not found',
        notFoundText: 'Nothing has been found',
        password: 'Password',
        passwordAgain: 'Password confirmation',
        passwordInfo: 'Fill in the password only if you want to change it.',
        passwordNotMatch: 'Passwords don not match!',
        passwordRulesUnmatched1: 'Password length must be between 8 and 32 characters',
        passwordRulesUnmatched2: 'Password must contain at least one lower case letter',
        passwordRulesUnmatched3: 'Password must contain at least one capital letter',
        passwordRulesUnmatched4: 'Password must contain at least one number',
        passwordRulesUnmatched5: 'Password must contain at least one non-alphanumeric character',
        Settings: 'Local settings',
        placeholderBasic: 'Basics',
        placeholderName: 'Group name',
        placeholderDescription: 'Description',
        placeholderType: 'Placeholder type',
        placeholderSimpleDescription: 'Single value type',
        placeholderMultipleDescription: 'More values is allowed',
        placeholderTypeSimple: 'Simple',
        placeholderTypeMultiple: 'Iterator',
        placeholderTypeImageCode: 'Image code',
        imageCodeGenerateButton: 'Generate code',
        imageCodeWidth: 'Width',
        imageCodeHeight: 'Height',
        imageCodeTypeDescription: 'Choose valid image code type',
        imageQrCodePayment: 'QR Payment',
        imageQrCodeURL: 'QR URL',
        imageQrCodeText: 'QR Text',
        imageCodeType: 'Type',
        imageQrCodePaymentAccount: 'Bank account',
        imageQrCodePaymentAmount: 'Amount',
        imageQrCodePaymentCurrency: 'Currency',
        imageQrCodePaymentDate: 'Due date',
        imageQrCodePaymentVS: 'Variable symbol',
        imageQrCodePaymentKS: 'Constant symbol',
        imageQrCodePaymentSS: 'Specific symbol',
        imageQrCodePaymentMessage: 'Message',
        imageCodeURL: 'URL',
        imageCodeText: 'Text',
        imageCodeChangeButton: 'Change code',
        imageCodePreviewButton: 'Preview code',
        placeholderKey: 'Key',
        placeholderKeyDescription: 'Key description',
        placeholderNewKey: 'New key',
        placeholderKeys: 'Keys',
        placeholderKeyValue: 'Value',
        placeholderKeySampleValues: 'Test values',
        palceholderKeyExists: 'Key name already exists within this group',
        palceholderNoKey: 'Type unique key name',
        placeholderNoValue: 'Enter value for key',
        tagName: 'Tag name',
        tagDescription: 'Tag desription',
        tagColor: 'Tag color',
        tagEnter: 'Enter tag',
        tagIsValid: 'Tag is used',
        tagIsNotValid: 'Tag is not used',
        templateVersionChangeLog: 'Version changelog',
        templateVersionSubject: 'Subject',
        templateVersion: 'Template version',
        templateVersionExpert: 'Expert',
        templateVersionCSS: 'CSS styles',
        templateVersionCSSButton: 'Edit CSS stylesheet',
        templateVersionState: 'Approval status',
        templateVersionStateApproved: 'Approved',
        templateVersionStateDraft: 'Draft',
        templateVersionFound: 'Template versions',
        templateTypeChoose: 'Select template type',
        templateSms: 'SMS',
        templatePdf: 'PDF',
        templateEmail: 'Email',
        templateName: 'Name',
        templateCode: 'Code',
        templateCodeChangeWarning:
            'Changing the code may cause a malfunction when generating or sending the template!',
        templateSelectForClone: 'Select a template version for cloning',
        templateExists: 'A template with the same code already exists',
        templateDescription: 'Description',
        templateInsertRow: 'Insert block',
        templateInsertRowBefore: 'Before active block',
        templateInsertRowAfter: 'After active block',
        templateRowColCount: 'Column count',
        templateShowBlocks: 'Highlight template blocks',
        templateShowBlocksShow: 'Blocks are highlighted',
        templateShowBlocksHide: 'Blocks are hidden',
        templateShowWideEditor: 'Show editor in tablet',
        templateShowWideEditorShow: 'Editor in tablet is active',
        templateShowWideEditorHide: 'Editor in phone is active',
        templateBlockDeletion: 'Delete the entire block',
        templateBlockDelete: 'Delete block',
        templateBlockDeleteAsk: 'Do you really want to delete this block({id})?',
        templatePreview: 'Preview',
        previewEmailSend: 'The preview email has been sent successfully',
        previewFileCreated: 'The preview file has been created',
        previewEmailNotSend: 'An error occurred while sending the preview',
        previewFileNotCreated: 'An error occurred while creating a preview',
        templatePreviewDescription:
            'Fill in all required fields and continue with the Send button.',
        templatePreviewNoPlaceholders: 'No placeholders were found. Continue with the Send button.',
        templateTextColor: 'Text color',
        templateBackgroundColor: 'Background color',
        templateBackgroundImage: 'Background image',
        templateBackgroundRepeat: 'Background repeat',
        templateBackgroundRepeatNoRepeat: 'No repeat',
        templateBackgroundRepeatRepeatX: 'Repeat horizontally',
        templateBackgroundRepeatRepeatY: 'Repeat vertically',
        templateBackgroundRepeatRepeat: 'Repeat',
        templateBackgroundSize: 'Background size',
        templateBackgroundSizeAuto: 'Automatically',
        templateBackgroundSizeXAuto: 'Automatically to width',
        templateBackgroundSizeCover: 'Cover',
        templateBackgroundSizeContain: 'All visible',
        templateBackgroundPositionX: 'Horizontal background position',
        templateBackgroundPositionY: 'Vertical background position',
        templateBackgroundPositionXLeft: 'Left',
        templateBackgroundPositionXCenter: 'Center',
        templateBackgroundPositionXRight: 'Right',
        templateBackgroundPositionYTop: 'Top',
        templateBackgroundPositionYCenter: 'Center',
        templateBackgroundPositionYBottom: 'Bottom',
        templateFontSize: 'Font size',
        templateFontStyle: 'Font style',
        templateFontStyleNormal: 'Normal',
        templateFontStyleItalic: 'Italic',
        templateFontWeight: 'Font weight',
        templateFontWeightNormal: 'Normal',
        templateFontWeightBold: 'Bold',
        templateTextAlign: 'Block text align',
        templateTextAlignLeft: 'Left',
        templateTextAlignRight: 'Right',
        templateTextAlignCenter: 'Centered',
        templateTextAlignJustify: 'Justify',
        templateContentWidth: 'Width',
        templateContentHeight: 'Height',
        templatePadding: 'Block padding',
        templatePaddingAdvanced: 'Advanced',
        templatePaddingAdvancedTop: 'Top',
        templatePaddingAdvancedRight: 'Right',
        templatePaddingAdvancedBottom: 'Bottom',
        templatePaddingAdvancedLeft: 'Left',
        templateSchemaDescription: 'The template data schema that is sent for processing',
        templateFooter: 'Footer',
        templateFooterDescription:
            'The footer of the template that is added to the end of each page',
        templateHeader: 'Header',
        templateHeaderDescription:
            'The header of the template that is added to the beginning of each page',
        templateMeta: 'Metadata',
        templateMetaOrigin: 'Origin',
        templateMetaAuthor: 'Author',
        templateMetaKeywords: 'Keywords',
        latest: 'Latest',
        version: 'Version',
        versionCount: 'Version count',
        created: 'Created on',
        updated: 'Last update on',
        Login: 'Sign in',
        Logout: 'Sign out',
        UITest: 'UI test',
        language: 'Language',
        templateLanguage: 'Template language',
        cs: 'Čeština',
        en: 'English',
        copyToClipboard: 'Copy to clipboard',
        copiedToClipboard: 'Copied to clipboard',
        footerDenial: 'Publication or distribution of content is prohibited.',
        labelSelectVariable: 'Select variable',
        labelValidJSON: 'Valid JSON',
        labelInvalidJSON: 'Invalid JSON',
        labelValidCSV: 'Valid CSV',
        labelInvalidCSV: 'Invalid CSV',
        labelValidDataset: 'Valid dataset',
        labelInvalidDataset: 'Invalid dataset',
        labelJSON: 'JSON',
        labelAPI: 'API',
        labelCSV: 'CSV',
        buttonOk: 'Ok',
        buttonChoose: 'Choose',
        buttonUse: 'Use',
        buttonCancel: 'Cancel',
        buttonClose: 'Close',
        buttonInsert: 'Insert',
        buttonInsertPlaceholder: 'Insert placeholder',
        buttonInsertImagePlaceholderData: 'Insert placeholder data',
        buttonInsertAsCondition: 'Insert as condition',
        buttonInsertAsImageCode: 'Insert QR or barcode',
        buttonInsertImageCode: 'Insert code',
        buttonInsertAsTable: 'Insert as table',
        buttonInsertIteratorStart: 'Loop start',
        buttonInsertIteratorEnd: 'Loop end',
        buttonInsertAsList: 'Insert as list',
        buttonInsertAsWidgetType: 'Element type',
        buttonRemoveCondition: 'Remove condition',
        buttonInsertConditionValue: 'Insert condition value',
        buttonRemoveConditionValue: 'Remove condition value',
        buttonConditionUseElse: 'Use else',
        buttonPreview: 'Create preview',
        buttonValidate: 'Validate',
        buttonYes: 'Yes',
        buttonNo: 'No',
        buttonBack: 'Back',
        buttonSave: 'Save',
        buttonSaveAs: 'Save as...',
        buttonSend: 'Send',
        buttonActivate: 'Activate',
        buttonDectivate: 'Deactivate',
        buttonAdd: 'Add',
        buttonAddRow: 'Add row',
        buttonRemove: 'Remove',
        buttonReset: 'Reset',
        buttonNewUser: 'New user',
        buttonNewSnippet: 'New snippet',
        buttonFormatSnippet: 'Format snippet',
        buttonNewTemplate: 'New template',
        buttonEditTemplate: 'Edit template',
        buttonNewTemplateVersion: 'New version',
        buttonNewPlaceholder: 'New group',
        buttonNewFile: 'New file',
        buttonNewTag: 'New tag',
        buttonAddTag: 'Add tag',
        buttonRemoveTag: 'Remove tag',
        buttonSaveAndClose: 'Save nad close',
        buttonSaveCopy: 'Save copy',
        buttonSetRole: 'Set role',
        buttonLogin: 'Sign in',
        buttonSendByEmail: 'Send by email',
        buttonNoEmailSend: 'No email',
        buttonSchema: 'Schema',
        buttonExportDuid: 'Export duid',
        buttonExportRecipient: 'Export recipient',
        buttonDownloadCSVFile: 'Download CSV file',
        buttonDownloadJSONFile: 'Download JSON file',
        buttonContinue: 'Continue',
        buttonImportJSON: 'Import JSON file',
        buttonExportJSON: 'Export JSON',
        buttonImport: 'Import',
        buttonExport: 'Export',
        buttonImportFromAnother: 'Import from another template',
        processFiles: 'Process files',
        editorToggleBold: 'Toggle Bold',
        editorToggleItalic: 'Toggle Italic',
        editorToggleStrike: 'Toggle Strike',
        editorToggleUnderline: 'Toggle Underline',
        editorToggleSuperscript: 'Superscript',
        editorToggleSubscript: 'Subscript',
        editorToggleTextAlignLeft: 'Align left',
        editorToggleTextAlignCenter: 'Align center',
        editorToggleTextAlignRight: 'Align right',
        editorToggleTextAlignJustify: 'Align justify',
        editorToggleParagraph: 'Paragraph',
        editorToggleDiv: 'Block (div)',
        editorToggleHeader: 'Header style',
        editorToggleHeader1: 'Header 1',
        editorToggleHeader2: 'Header 2',
        editorToggleHeader3: 'Header 3',
        editorToggleHeader4: 'Header 4',
        editorToggleHeader5: 'Header 5',
        editorToggleHeader6: 'Header 6',
        editorInsertImage: 'Insert image',
        editorInsertImageUrl: 'URL',
        editorInsertImageCannotUse: 'This image source cannot be used, wrong format {format}',
        editorInsertImageWidth: 'Image width',
        editorInsertImageHeight: 'Image height',
        editorInsertImageAlt: 'Image alt text',
        editorEditImage: 'Edit image',
        editorInsertLink: 'Insert link',
        editorRemoveLink: 'Remove link',
        editorInsertProtocolAndAddress: 'Type protokol and link address',
        editorLinkInvalid: 'This link cannot be used',
        editorLinkValid: 'This link is valid',
        editorToggleBlockqoute: 'Blockquote',
        editorToggleHighlight: 'Highlight',
        editorToggleClearFormatting: 'Clear formatting',
        editorToggleBulletList: 'Bullet list',
        editorToggleOrderedList: 'Ordered list',
        editorLiftListItem: 'Decrease indent',
        editorSinkListItem: 'Increase indent',
        editorSetHorizontalRule: 'Insert horizontal rule',
        editorSetPageBreak: 'Insert page break',
        editorPageBreak: 'Page break',
        editorUndo: 'Undo',
        editorRedo: 'Redo',
        editorInsertTable: 'Insert table',
        editorAddColumnBefore: 'Add column before',
        editorAddColumnAfter: 'Add column after',
        editorDeleteColumn: 'Delete column',
        editorAddRowBefore: 'Add row before',
        editorAddRowAfter: 'Add row after',
        editorDeleteRow: 'Delete row',
        editorDeleteTable: 'Delete table',
        editorMergeCells: 'Merge cells',
        editorSplitCell: 'Split cell',
        editorToggleHeaderColumn: 'Toggle first column cells header',
        editorToggleHeaderRow: 'Toggle first row cells header',
        editorToggleHeaderCell: 'Toggle header cell',
        editorInsertVariable: 'Insert variable',
        editorVariables: 'Variables',
        imageEditorPreview: 'Save image',
        imageEditorPreviewText: 'Image preview for saving',
        imageEditorOpenFile: 'Open file',
        imageEditorRotateLeft: 'Rotate left',
        imageEditorRotateRight: 'Rotate right',
        imageEditorFlipH: 'Flip horizontally',
        imageEditorFlipV: 'Flip vertically',
        imageEditorZoomIn: 'Zoom in',
        imageEditorZoomOut: 'Zoom out',
        imageEditorMoveLeft: 'Move left',
        imageEditorMoveRight: 'Move right',
        imageEditorMoveUp: 'Move up',
        imageEditorMoveDown: 'Movve down',
        imageEditorCrop: 'Crop and save',
        imageEditorRevert: 'Revert changes',
        imageListPreview: 'Directory listing',
        imageListPreviewText: '[0] no files |[1] one file |[2,*] {count} files',
        imageEditorFilename: 'File name',
        multipleUploadFilesSentTitle: 'Sending complete',
        multipleUploadFilesSent: 'Files have been successfully sent for processing',
        welcomeText: 'Welcome in application',
        backendServerNote: 'Backend server',
        fileServerNote: 'File storage server',
        templateStatsNote: 'Template types',
        placeholderStatsNote: 'Placeholder groups (variable count)',
        placeholderSimpleStatsNote: 'Simple placeholders',
        placeholderMultipleStatsNote: 'Iterator placeholders',
        placeholderImageCodeStatsNote: 'Image code placeholders',
        serverOk: '{serverName} is up',
        serverFail: '{serverName} is not down',
        notifyOk: 'Done',
        notifyError: 'Error',
        notifyMessageSaved: 'The request was saved',
        paginatorPage: 'Page',
        paginatorPrev: 'Previous',
        paginatorNext: 'Next',
        orderBy: 'Order by',
        error404: 'Error 404 - not found',
        error404Text: 'Requested page was not found on the server',
        backHome: 'Back to home',
        filterAll: 'No filter',
        sortName: 'Name',
        sortCode: 'Code',
        sortUserName: 'Username',
        sortLastName: 'Last name',
        sortEmail: 'Email',
        sortType: 'Type',
        sortVersion: 'Version',
        sortLangCode: 'Language',
        sortSubject: 'Subject',
        sortState: 'State',
        sortCreated: 'Created date',
        sortUpdated: 'Updated date',
        validationCompliant: 'Compliant',
        validationNonCompliant: 'Non-compliant',
        validationPassedChecks: 'Passed checks',
        validationFailedChecks: 'Failed checks',
        validationTotalChecks: 'Total checks',
        validationResultClause: 'Clause',
        validationResultContext: 'Context',
        validationResultDescription: 'Description',
        validationResultRuleId: 'Rule ID',
        validationResultTestNumber: 'Test number',
        templateValidationDescription:
            'The template validation results for blind. Below you can find the list of found errors, warnings and information. Note: even if the template may seem functional, it is recommended to fix all errors and warnings to ensure proper functionality.',
        isPdfUaStrict: 'Accessibility for blind (PDF/UA)',
        isPdfUaStrictOn: 'Accessibility is required',
        isPdfUaStrictOff: 'Accessibility is not required',
    };

    return {
        all,
    };
};

export default en;
